// ===========================================================================
// EL SELLO VIVO: QUE VERSION ESTA SIRVIENDO CADA SITIO AHORA MISMO
// (PANEL-PROYECTOS-SELLO-VIVO-T1).
//
// DE DONDE SALE. La tarjeta de proyectos mostraba la version TECLEADA en la
// base. El API decia 1.6.28 y produccion servia 1.6.491: cuatrocientas
// versiones de diferencia, y nadie mirando la tarjeta podia saberlo. Josse
// decidio el 11-sep que se arregle ese numero primero.
//
// LO QUE NO SE HACE, y lo pidio Ares explicito: no se borra el numero tecleado.
// Queda como lo que es -- un dato escrito a mano -- y AL LADO va el vivo. Dos
// numeros con su definicion, igual que quedo el indicador de -nos conocemos-.
//
// UN SELLO QUE NO SE PUEDE LEER DICE POR QUE, Y NO DICE EL NUMERO VIEJO. Un
// mensaje unico para todos los fallos hace dudar de lo que si funciona, asi que
// cada estado tiene su causa:
//
//   servido        se leyo y trae version
//   sin-version    contesto, pero el JSON no trae version
//   no-se-leyo     no se pudo leer, y NO SABEMOS POR QUE
//   sin-sello      ese proyecto no tiene sello publicado todavia
//
// LO QUE ESTE ARCHIVO NO PUEDE SABER, Y POR ESO NO LO DICE.
//
// La primera version tenia un estado -sin-permiso- cuyo texto afirmaba: -el
// sitio contesta, pero no nos deja leerlo. NO quiere decir que este caido-.
// Ese estado salia de UNA sola pregunta -- la direccion es de otro sitio? --
// y de ninguna evidencia sobre el fallo.
//
// Argy-Q lo midio con TRES fallos distintos -- sitio caido de verdad, sitio
// que se pasa de la espera, y sitio que no da permiso de lectura -- y los
// tres devolvian el mismo estado y el mismo texto. O sea que el dia que el
// arcade se cayera, la tarjeta iba a AFIRMAR EN VOZ ALTA que no estaba caido.
//
// Eso es peor que el defecto que veniamos arreglando: aquel mandaba a buscar
// una caida que no existia; este esconde una que si. Lo dijo Ares en #13993.
//
// El navegador TAPA el motivo de estos fallos a proposito, por seguridad. Asi
// que desde aqui no se puede distinguir, y la unica frase honesta es decir
// que no se pudo leer y cuales son las posibilidades, sin descartar ninguna.
// ===========================================================================

/**
 * DONDE VIVE EL SELLO DE CADA UNO, y por que no sale de deploy_url.
 *
 * La base tiene deploy_url para cuatro proyectos, pero la ruta del sello no es
 * la misma en todos -- el API lo pone en /api/Health y los demas en
 * /version.json -- y el arcade todavia no tiene deploy_url escrito. Cuando esa
 * columna este completa, esta tabla se puede mover a datos; hoy seria inventar
 * una regla que no se cumple.
 */
const SELLOS = {
  'nexo-api': {
    url: 'https://api.nexodigital360.com/api/Health',
    // El API trae "1.6.491+521f4c5affde...": semver, un mas, y el commit.
    leer: (j) => ({ version: String(j.version || '').split('+')[0], commit: String(j.version || '').split('+')[1] || '' })
  },
  'panel-v2': {
    url: 'https://panel.nexodigital360.com/version.json',
    leer: (j) => ({ version: j.version, commit: j.commit })
  },
  'nexo-arcade': {
    url: 'https://arcade.nexodigital360.com/version.json',
    leer: (j) => ({ version: j.version, commit: j.commit, extra: j.numeroBuild ? 'build ' + j.numeroBuild : '' })
  },
  'nexo-web': {
    url: 'https://nexodigital360.com/version.json',
    leer: (j) => ({ version: j.version, commit: j.commit })
  }
  // nexo-desktop NO esta: su manifiesto de actualizaciones vive en
  // updates.nexodigital360.com/releases/v1/ y ese directorio contesta 403, sin
  // indice. Probe siete nombres de archivo habituales y los siete dieron 404.
  // No invento la ruta: mientras no se sepa, su tarjeta dice sin-sello con esta
  // razon, que es informacion y no un hueco mudo.
};

const ESPERA_MS = 6000;

/**
 * Pregunta el sello de UN proyecto. No lanza nunca: devuelve el estado.
 *
 * @param {string} projectKey
 * @returns {Promise<{estado:string, version:string, commit:string, extra:string, porque:string}>}
 */
export async function selloDe(projectKey) {
  const s = SELLOS[projectKey];
  if (!s) {
    return {
      estado: 'sin-sello', version: '', commit: '', extra: '',
      porque: projectKey === 'nexo-desktop'
        ? 'el manifiesto de actualizaciones no tiene una ruta publicada que se pueda leer'
        : 'este proyecto todavia no publica un sello de version'
    };
  }
  let r;
  try {
    r = await fetch(s.url, { cache: 'no-store', signal: AbortSignal.timeout(ESPERA_MS) });
  } catch (e) {
    // NO SE AFIRMA LA CAUSA. Lo unico que se sabe es que no se pudo leer.
    // Si el sello es de otro sitio, el navegador esconde el motivo y las tres
    // posibilidades quedan abiertas; se nombran todas y no se descarta ninguna.
    // Si es del mismo sitio, el mensaje del error SI llega y se pasa tal cual.
    const ajeno = !s.url.startsWith(location.origin);
    return {
      estado: 'no-se-leyo', version: '', commit: '', extra: '',
      porque: ajeno
        ? 'no se pudo leer el sello y desde el panel no se puede saber por que: el navegador esconde el motivo cuando el sitio es otro. Puede estar caido, puede haberse pasado de los ' + (ESPERA_MS / 1000) + ' segundos, o puede no darnos permiso de lectura. Para saberlo hay que abrir el sitio.'
        : 'no se pudo leer el sello: ' + (e && e.message ? e.message : 'sin detalle')
    };
  }
  if (!r.ok) {
    return { estado: 'no-se-leyo', version: '', commit: '', extra: '', porque: 'el sello contesto ' + r.status };
  }
  let j;
  try { j = await r.json(); } catch {
    return { estado: 'sin-version', version: '', commit: '', extra: '', porque: 'contesto algo que no es JSON' };
  }
  const { version, commit, extra } = s.leer(j) || {};
  if (!version) {
    return { estado: 'sin-version', version: '', commit: commit || '', extra: extra || '', porque: 'el sello contesta y no trae version' };
  }
  return { estado: 'servido', version: String(version), commit: String(commit || ''), extra: String(extra || ''), porque: '' };
}

/** Los proyectos que tienen sello declarado. Lo usa el guardia. */
export function proyectosConSello() {
  return Object.keys(SELLOS);
}

/** Como se lee cada estado en pantalla, en palabras y no en codigos. */
export function textoDelEstado(sello) {
  if (!sello) return 'midiendo...';
  if (sello.estado === 'servido') return 'sirviendo v' + sello.version + (sello.extra ? ' (' + sello.extra + ')' : '');
  return 'NO MEDIDO';
}
